import { format, subDays, subWeeks, subMonths, subYears } from "date-fns";

export const DATE_PRESETS = [
  { key: "1d", label: "1D" },
  { key: "1w", label: "1W" },
  { key: "1m", label: "1M" },
  { key: "6m", label: "6M" },
  { key: "1y", label: "1Y" },
  { key: "5y", label: "5Y" },
];

const SUBTRACT = {
  "1d": (d) => subDays(d, 1),
  "1w": (d) => subWeeks(d, 1),
  "1m": (d) => subMonths(d, 1),
  "6m": (d) => subMonths(d, 6),
  "1y": (d) => subYears(d, 1),
  "5y": (d) => subYears(d, 5),
};

/** Local-time YYYY-MM-DD range ending today. Never uses toISOString (UTC shift). */
export function presetRange(key, today = new Date()) {
  const fn = SUBTRACT[key];
  return {
    from: fn ? format(fn(today), "yyyy-MM-dd") : "",
    to: format(today, "yyyy-MM-dd"),
  };
}

export default function DatePresets({ from, to, onChange, className = "" }) {
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="date-presets">
      {DATE_PRESETS.map(({ key, label }) => {
        const r = presetRange(key);
        const active = !!from && from === r.from && to === r.to;
        return (
          <button
            key={key}
            type="button"
            aria-pressed={active}
            data-testid={`date-preset-${key}`}
            onClick={() => (active ? onChange("", "") : onChange(r.from, r.to))}
            className={`h-7 px-2 text-xs rounded border transition-colors ${
              active
                ? "bg-indigo-50 border-indigo-300 text-indigo-700 font-medium"
                : "border-gray-200 text-gray-600 hover:bg-gray-50"
            }`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
